
import { createSlice } from "@reduxjs/toolkit";

const initialWorkqueueState = {
    // activePatient: null,
    currentpage: 1,
    currentpagedata: null,
    listFiltersParams: null,
    pageResults: null,
    isAPracticeUsedAsFilter: null,
    selectedWorkQueue: null,
    clearFilters: false,
    genericWorkQueue: null,
    activeDrawer: null,
    refreshApi: 0,
    initialLoad: null,
    lastActiveCase: null,
    editSessionCount: 0,
}

const workqueueSlice = createSlice({
    name: 'workqueue',
    initialState: initialWorkqueueState,
    reducers: {
        // setActivepatient(state, data) {
        //     state.activePatient = data.payload
        // },   
        setCurrentPage(state, data) {
            state.currentpage = data.payload
        },
        setCurrentPageData(state, data) {
            state.currentpagedata = data.payload
        },
        saveListFiltersParams(state, data) {
            state.listFiltersParams = data.payload
        },
        setPageResults(state, data) {
            state.pageResults = data.payload
        },
        setIsAPracticeUsedAsFilter(state, data) {
            state.isAPracticeUsedAsFilter = data.payload
        },
        setSelectedWorkQueue(state, data) {
            state.selectedWorkQueue = data.payload
        },
        setClearFilters(state, data) {
            state.clearFilters = data.payload
        },
        setGenericWorkQueue(state, data) {
            state.genericWorkQueue = data.payload
        },
        deleteFromGenericWorkQueue(state, data) {
            const index = state.genericWorkQueue.findIndex(object => {
                return object.groupName == data.payload.groupName
            })

            if (index !== -1) {
                state.genericWorkQueue.splice(index, 1)
            }
        },
        addToGenericWorkQueue(state, data) {
            state.genericWorkQueue.push(data.payload)
        },
        setPositionOnGenericWorkQueue(state, data) {            
            const [removed] = state.genericWorkQueue.splice(data.payload.startIndex, 1);
            state.genericWorkQueue.splice(data.payload.endIndex, 0, removed);
        },   
        setPositionOnGenericWorkQueueItem(state, data) { 
            const index = state.genericWorkQueue.findIndex(object => {
                return object.groupName == data.payload.groupName
            })  
            
            if (index !== -1) {
                const [removed] = state.genericWorkQueue[index].items.splice(data.payload.startIndex, 1);
                state.genericWorkQueue[index].items.splice(data.payload.endIndex, 0, removed);
            }

            
        },     
        setOpenedDrawer(state, data) {
            if (state.activeDrawer == data.payload) {
                state.activeDrawer = null
            } else {
                state.activeDrawer = data.payload
            }
            // state.activeDrawer = data.payload
        },
        setRefreshApi(state) {
            state.refreshApi = state.refreshApi + 1
        },
        beginEditSession(state) {
            state.editSessionCount += 1
        },
        endEditSession(state) {
            state.editSessionCount = Math.max(0, state.editSessionCount - 1)
        },
        setInitialLoad(state, data) {
            state.initialLoad = data.payload
        },
        setLastActiveCase(state, data) {
            state.lastActiveCase = data.payload
        }
    }
})

export const workqueueActions = workqueueSlice.actions

export default workqueueSlice.reducer